const navComponentsQuery = /* GraphQL */ `
  query NavComponentsQuery {
    allComponents(
      filter: {
        name: {
          in: [
            "v1-nav-drawer-services"
            "v1-nav-drawer-environmental"
            "v1-nav-drawer-cameras"
            "v1-nav-drawer-home-security"
          ]
        }
      }
    ) {
      id
      name
      images {
        name
        image {
          id
          url
          alt
          title
        }
      }
    }
  }
`;

const data = {
  allComponents: [
    {
      componentName: 'v1-nav-drawer-services',
      images: [
        {
          imageName: 'installing-sensor',
          image: {
            url: 'https://www.datocms-assets.com/10154/1657226522-women-installing-a-cove-motion-detector.png',
            id: '47218248',
            alt: 'Women installing a Cove motion detector',
            title: 'Women installing a Cove motion detector',
          },
        },
      ],
    },
    {
      componentName: 'v1-nav-drawer-environmental',
      images: [
        {
          imageName: 'environmental-detectors',
          image: {
            url: 'https://www.datocms-assets.com/10154/1687366200-smoke-detector-flood-detector.png',
            id: '49642880',
            alt: "Cove's environmental detectors",
            title: "Image of Cove's environmental detectors",
          },
        },
        {
          imageName: 'smoke-carbon',
          image: {
            url: 'https://www.datocms-assets.com/10154/1687366261-smoke-detector.png',
            id: '47218245',
            alt: "Cove's smoke detector",
            title: "Image of Cove's smoke detector",
          },
        },
        {
          imageName: 'co-detector',
          image: {
            url: 'https://www.datocms-assets.com/10154/1683810444-carbon-monoxide-detector.png',
            id: '49642877',
            alt: "Cove's carbon monoxide detector",
            title: "Image of Cove's carbon monoxide detector",
          },
        },
        {
          imageName: 'flood-sensor',
          image: {
            url: 'https://www.datocms-assets.com/10154/1657226477-image-of-cove-s-flood-sensor.png',
            id: '47218247',
            alt: "Cove's flood sensor",
            title: "Image of Cove's flood sensor",
          },
        },
      ],
    },
    {
      componentName: 'v1-nav-drawer-cameras',
      images: [
        {
          imageName: 'cove-cameras',
          image: {
            url: 'https://www.datocms-assets.com/10154/1687881232-cove-cameras.png',
            id: '49642780',
            alt: "Cove's cameras",
            title: "Image of Cove's cameras",
          },
        },
        {
          imageName: 'cove-cameras-eufy',
          image: {
            id: '49420532',
            url: 'https://www.datocms-assets.com/10154/1686083167-cameras.png',
            alt: "Cove's cameras",
            title: "Image of Cove's cameras",
          },
        },
        {
          imageName: 'indoor-camera',
          image: {
            url: 'https://www.datocms-assets.com/10154/1686083155-eufy-indoor-camera.png',
            id: '47218229',
            alt: "Cove's indoor camera",
            title: "Image of Cove's indoor camera",
          },
        },
        {
          imageName: 'outdoor-camera',
          image: {
            url: 'https://www.datocms-assets.com/10154/1657225711-image-of-cove-s-outdoor-camera.png',
            id: '47218230',
            alt: "Cove's outdoor camera",
            title: "Image of Cove's outdoor camera",
          },
        },
        {
          imageName: 'compatible-doorbells',
          image: {
            url: 'https://www.datocms-assets.com/10154/1657225753-image-of-cove-compatible-doorbell-cameras.png',
            id: '47218231',
            alt: 'Cove compatible doorbell cameras',
            title: 'Image of Cove compatible doorbell cameras',
          },
        },
        {
          imageName: 'eufy-compatible-doorbells',
          image: {
            id: '49420556',
            url: 'https://www.datocms-assets.com/10154/1680816678-eufy-and-skybell-doorbell-cameras.png',
            alt: 'Image of Eufy and Skybell Doorbell Cameras',
            title: 'Eufy and Skybell Doorbell Cameras',
          },
        },
        {
          imageName: 'skybell-doorbell',
          image: {
            url: 'https://www.datocms-assets.com/10154/1683810232-skybell-doorbell-camera.png',
            id: '49642868',
            alt: 'Skybell doorbell camera',
            title: 'Image of Skybell doorbell camera',
          },
        },
        {
          imageName: 'eufy-outdoor-camera',
          image: {
            id: '49642864',
            url: 'https://www.datocms-assets.com/10154/1683810220-eufy-outdoor-camera.png',
            alt: 'Image of Eufy Outdoor Camera',
            title: 'Eufy Outdoor Camera',
          },
        },
        {
          imageName: 'eufy-doorbell-camera',
          image: {
            id: '49420543',
            url: 'https://www.datocms-assets.com/10154/1680816007-eufy-doorbell-camera.png',
            alt: 'Image of Eufy Doorbell Camera',
            title: 'Eufy Doorbell Camera',
          },
        },
      ],
    },
    {
      componentName: 'v1-nav-drawer-home-security',
      images: [
        {
          imageName: 'cove-sensors',
          image: {
            url: 'https://www.datocms-assets.com/10154/1687363195-cove-home-security-products.png',
            id: '49642913',
            alt: "Cove's home security equipment",
            title: "Image of Cove's home security equipment",
          },
        },
        {
          imageName: 'alarm-panel-hub',
          image: {
            url: 'https://www.datocms-assets.com/10154/1687363216-hub-and-touch-screen.png',
            id: '49642931',
            alt: "Cove's alarm panel and hub",
            title: "Image of Cove's alarm panel and hub",
          },
        },
        {
          imageName: 'door-sensor',
          image: {
            url: 'https://www.datocms-assets.com/10154/1657225134-window-sensor.png',
            id: '47218216',
            alt: "Cove's Door/Window sensor",
            title: "Image of Cove's Door/Window sensor",
          },
        },
        {
          imageName: 'window-sensor',
          image: {
            url: 'https://www.datocms-assets.com/10154/1657225134-window-sensor.png',
            id: '47218216',
            alt: "Cove's Door/Window sensor",
            title: "Image of Cove's Door/Window sensor",
          },
        },
        {
          imageName: 'motion-detector',
          image: {
            url: 'https://www.datocms-assets.com/10154/1657225228-image-of-cove-s-motion-detector.png',
            id: '47218219',
            alt: "Cove's motion detector",
            title: "Image of Cove's motion detector",
          },
        },
        {
          imageName: 'glass-break',
          image: {
            url: 'https://www.datocms-assets.com/10154/1657225443-image-of-cove-s-glass-break-detector.png',
            id: '47218224',
            alt: "Cove's glass break detector",
            title: "Image of Cove's glass break detector",
          },
        },
        {
          imageName: 'medical-button',
          image: {
            url: 'https://www.datocms-assets.com/10154/1683810469-medical-button.png',
            id: '49642881',
            alt: "Cove's Medical Button",
            title: "Image of Cove's Medical Button",
          },
        },
        {
          imageName: 'key-remote',
          image: {
            url: 'https://www.datocms-assets.com/10154/1657225536-image-of-cove-s-key-remote.png',
            id: '47218227',
            alt: "Cove's key remote",
            title: "Image of Cove's key remote",
          },
        },
        {
          imageName: 'siren',
          image: {
            url: 'https://www.datocms-assets.com/10154/1683811673-siren.png',
            id: '49642955',
            alt: "Cove's siren",
            title: "Image of Cove's siren",
          },
        },
      ],
    },
  ],
};

export { data };
